import { isPlatformBrowser } from '@angular/common';
import {  ChangeDetectorRef, Component,  Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'clever-preisalarme',
    templateUrl: './preisalarme.component.html',
    styleUrls: ['./preisalarme.component.scss'],
    standalone: false
})
export class PreisalarmeComponent implements OnInit {
    protected unsubscribe$ = new Subject();
    preisAlarm: boolean = false;
    isBrowser: boolean = false;
    constructor(
        protected hotelService: HotelFiltersService,
        protected cdr: ChangeDetectorRef,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.initFilterSub();
        }
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }

    checkPra(ev): void {
        ev?.stopPropagation();
        ev?.preventDefault();
        if (!this.preisAlarm) {
            this.hotelService.setOpenPreisAlarmModal$(true);
        }
    }

    checkPratogel(): void {
        if (this.preisAlarm) {
            this.hotelService.setOpenPreisAlarmModal$(true);
        }
    }

    initFilterSub(): void {
        this.hotelService.preisAlarm$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((val: boolean) => {
            this.preisAlarm = val;
            this.cdr.detectChanges();
        });
    }

    async gotoPreisAlarm() {
        this.hotelService.gotoPreisAlarm();
    }
}
